/* ── Studio Phalsa — Search Overlay JS ──────────────────────────
   Opens/closes the overlay rendered by snippets/sp-search-overlay.liquid
   and drives predictive search via /search/suggest.json. */
(function () {
  'use strict';

  const trigger = document.getElementById('sp-search-trigger');
  const overlay = document.getElementById('sp-search-overlay');
  const backdrop = document.getElementById('sp-search-backdrop');
  if (!trigger || !overlay || !backdrop) return;

  const input = document.getElementById('sp-search-input');
  const closeBtn = document.getElementById('sp-search-close');
  const resultsContainer = document.getElementById('sp-search-results');

  let debounceTimer;

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function openSearch() {
    overlay.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 300);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    resultsContainer.innerHTML = '';
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    openSearch();
  });

  closeBtn.addEventListener('click', closeSearch);

  backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      const query = input.value.trim();
      if (query.length < 2) {
        resultsContainer.innerHTML = '';
        return;
      }
      fetchResults(query);
    }, 300);
  });

  async function fetchResults(query) {
    resultsContainer.innerHTML = renderSkeletons();
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
      );
      const data = await response.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (products.length === 0) {
        resultsContainer.innerHTML =
          '<p class="sp-search__no-results">No results found for "' + escapeHtml(query) + '"</p>';
        return;
      }
      resultsContainer.innerHTML = products.map(renderResult).join('');
    } catch (err) {
      resultsContainer.innerHTML = '';
    }
  }

  function renderResult(product) {
    const image = product.featured_image && product.featured_image.url;
    const img = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="60" height="80">'
      : '<img src="" alt="" width="60" height="80" style="visibility:hidden;">';
    const price = typeof product.price === 'number'
      ? '₹' + (product.price / 100).toLocaleString('en-IN')
      : '';
    return '<a href="' + escapeHtml(product.url) + '" class="sp-search__result">' +
      img +
      '<div class="sp-search__result-info">' +
      '<p class="sp-search__result-name">' + escapeHtml(product.title) + '</p>' +
      '<p class="sp-search__result-price">' + price + '</p>' +
      '</div>' +
      '</a>';
  }

  function renderSkeletons() {
    return Array(3).fill(
      '<div class="sp-search__skeleton">' +
      '<div class="sp-search__skeleton-img"></div>' +
      '<div class="sp-search__skeleton-text">' +
      '<div class="sp-search__skeleton-line"></div>' +
      '<div class="sp-search__skeleton-line sp-search__skeleton-line--short"></div>' +
      '</div></div>'
    ).join('');
  }
})();
